/* Yake Ürün Yorumları — App Proxy tabanlı (bağımsız, native temalı). */
(function () {
  'use strict';

  var cfgEl = document.querySelector('[data-yake-reviews-config]');
  var root = document.querySelector('[data-yake-reviews]');
  if (!cfgEl || !root) return;

  var CFG = {};
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var summaryEl = root.querySelector('[data-yake-reviews-summary]');
  var formEl = root.querySelector('[data-yake-reviews-form]');
  var listEl = root.querySelector('[data-yake-reviews-list]');
  var proxy = (CFG.proxyBase || '/apps/yake-collection').replace(/\/$/, '');
  var MAX_IMG = CFG.maxImages || 3;

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function fmtDate(iso) {
    try { return new Date(iso).toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' }); }
    catch (e) { return ''; }
  }
  function imgUrl(rel) { return proxy + '/' + String(rel).replace(/^\/?/, ''); }
  function initialOf(name) {
    var t = (name || '?').trim();
    return t ? t.charAt(0).toLocaleUpperCase('tr') : '?';
  }

  // Katmanlı, kesirli altın yıldızlar
  function starsHtml(rating, lg) {
    var pct = Math.max(0, Math.min(100, (Number(rating) || 0) / 5 * 100));
    return '<span class="yr-stars' + (lg ? ' yr-stars--lg' : '') + '">' +
      '<span class="yr-stars__bg">★★★★★</span>' +
      '<span class="yr-stars__fg" style="width:' + pct + '%">★★★★★</span>' +
      '</span>';
  }

  // Net (dolu/boş) yıldızlar — tam-sayı puanlar için (kesirli hizalama sorunu olmaz)
  function starsInt(n) {
    n = Math.round(Number(n) || 0);
    var s = '';
    for (var i = 1; i <= 5; i++) s += '<span class="yr-s' + (i <= n ? ' on' : '') + '">★</span>';
    return '<span class="yr-stars-int">' + s + '</span>';
  }

  function renderSummary(s) {
    if (!s || !s.count) {
      summaryEl.innerHTML = '<div class="yr-summary yr-summary--empty">Henüz değerlendirme yok. İlk yorumu sen yaz!</div>';
      return;
    }
    var avg = (Math.round(s.average * 10) / 10).toString().replace('.', ',');
    summaryEl.innerHTML =
      '<div class="yr-summary">' +
        '<span class="yr-summary__avg">' + avg + '</span>' +
        '<span class="yr-summary__right">' +
          starsHtml(s.average, true) +
          '<span class="yr-summary__count">' + s.count + ' değerlendirme</span>' +
        '</span>' +
      '</div>';
  }

  var INITIAL_REVIEWS = 2;
  var reviewsAll = [];
  var fStars = [], fPhotos = false, fSort = 'new'; // fStars: seçili yıldızlar (çoklu); boş = hepsi

  function itemHtml(r, hidden) {
    var imgs = (r.images || []).map(function (u) {
      var url = imgUrl(u);
      return '<a href="' + esc(url) + '" target="_blank" rel="noopener"><img src="' + esc(url) + '" alt="" loading="lazy"></a>';
    }).join('');
    return '<div class="yr-item' + (hidden ? ' yr-hidden' : '') + '">' +
      '<div class="yr-item__top">' +
        '<span class="yr-avatar">' + esc(initialOf(r.customerName)) + '</span>' +
        '<span class="yr-meta">' +
          '<span class="yr-name">' + esc(r.customerName) + (r.verifiedPurchase ? '<span class="yr-vp">✓ doğrulanmış alıcı</span>' : '') + '</span>' +
          starsInt(r.rating) +
        '</span>' +
        '<span class="yr-date">' + esc(fmtDate(r.createdAt)) + '</span>' +
      '</div>' +
      (r.variant ? '<div class="yr-variant">' + esc(r.variant) + '</div>' : '') +
      (r.title ? '<div class="yr-title">' + esc(r.title) + '</div>' : '') +
      (r.body ? '<div class="yr-body">' + esc(r.body) + '</div>' : '') +
      (imgs ? '<div class="yr-imgs">' + imgs + '</div>' : '') +
    '</div>';
  }

  function applyFilterSort(arr) {
    var out = arr.filter(function (r) {
      if (fStars.length && fStars.indexOf(r.rating) === -1) return false;
      if (fPhotos && !(r.images && r.images.length)) return false;
      return true;
    });
    out.sort(function (a, b) {
      if (fSort === 'high') return (b.rating || 0) - (a.rating || 0);
      if (fSort === 'low') return (a.rating || 0) - (b.rating || 0);
      return new Date(b.createdAt) - new Date(a.createdAt);
    });
    return out;
  }

  function toolbarHtml() {
    if (reviewsAll.length < 2) return '';
    var chips = [0, 5, 4, 3, 2, 1].map(function (s) {
      var on = s === 0 ? fStars.length === 0 : fStars.indexOf(s) >= 0;
      return '<button type="button" class="yr-chip' + (on ? ' is-on' : '') + '" data-star="' + s + '">' + (s === 0 ? 'Tümü' : s + '★') + '</button>';
    }).join('');
    return '<div class="yr-toolbar">' +
      '<div class="yr-chips">' + chips +
        '<button type="button" class="yr-chip' + (fPhotos ? ' is-on' : '') + '" data-photos>📷 Fotoğraflı</button>' +
      '</div>' +
      '<select class="yr-sort" data-sort>' +
        '<option value="new"' + (fSort === 'new' ? ' selected' : '') + '>En yeni</option>' +
        '<option value="high"' + (fSort === 'high' ? ' selected' : '') + '>En yüksek puan</option>' +
        '<option value="low"' + (fSort === 'low' ? ' selected' : '') + '>En düşük puan</option>' +
      '</select>' +
    '</div>';
  }

  function renderReviews() {
    root.classList.toggle('yr-no-reviews', !reviewsAll.length);
    var filtered = applyFilterSort(reviewsAll);
    var itemsHtml = filtered.length
      ? filtered.map(function (r, idx) { return itemHtml(r, idx >= INITIAL_REVIEWS); }).join('')
      : '<p class="yr-muted">Bu filtreye uygun yorum yok.</p>';
    var moreBtn = filtered.length > INITIAL_REVIEWS
      ? '<button type="button" class="yr-more" data-more>Daha fazlasını gör (' + filtered.length + ' değerlendirme)</button>'
      : '';
    listEl.innerHTML = toolbarHtml() + '<div class="yr-items" data-yr-items>' + itemsHtml + '</div>' + moreBtn;
    listEl.querySelectorAll('[data-star]').forEach(function (b) {
      b.addEventListener('click', function () {
        var s = parseInt(b.getAttribute('data-star'), 10);
        if (s === 0) { fStars = []; } // "Tümü" → temizle
        else { var i = fStars.indexOf(s); if (i >= 0) fStars.splice(i, 1); else fStars.push(s); } // çoklu seç/kaldır
        renderReviews();
      });
    });
    var ph = listEl.querySelector('[data-photos]');
    if (ph) ph.addEventListener('click', function () { fPhotos = !fPhotos; renderReviews(); });
    var sortSel = listEl.querySelector('[data-sort]');
    if (sortSel) sortSel.addEventListener('change', function () { fSort = sortSel.value; renderReviews(); });
    var more = listEl.querySelector('[data-more]');
    if (more) more.addEventListener('click', function () {
      var items = listEl.querySelector('[data-yr-items]');
      if (items) items.classList.add('yr-list--expanded');
      more.remove();
    });
  }

  function renderList(items) { reviewsAll = items || []; renderReviews(); }

  function statusLabel(s) {
    return s === 'approved' ? 'Onaylandı' : s === 'rejected' ? 'Reddedildi' : 'Değerlendirme sürecinde';
  }

  // Müşterinin kendi yorumu + durumu (satın almış + yorum yazmışsa)
  function myReviewHtml(m) {
    var imgs = (m.images || []).map(function (u) {
      var url = imgUrl(u);
      return '<a href="' + esc(url) + '" target="_blank" rel="noopener"><img src="' + esc(url) + '" alt="" loading="lazy"></a>';
    }).join('');
    return '<div class="yr-myreview">' +
      '<div class="yr-myreview__head"><span class="yr-myreview__t">Değerlendirmeniz</span>' +
      '<span class="yr-status yr-status--' + esc(m.status) + '">' + statusLabel(m.status) + '</span></div>' +
      starsHtml(m.rating) +
      (m.title ? '<div class="yr-title">' + esc(m.title) + '</div>' : '') +
      (m.body ? '<div class="yr-body">' + esc(m.body) + '</div>' : '') +
      (imgs ? '<div class="yr-imgs">' + imgs + '</div>' : '') +
      '</div>';
  }

  function formMarkup() {
    return '<form class="yr-form" novalidate>' +
        '<div class="yr-form__title h5">Değerlendirmenizi yazın</div>' +
        '<div class="yr-field">' +
          '<label class="yr-field__label">Puanınız <span style="color:#dc2626">*</span></label>' +
          '<div class="yr-stars-input">' +
            [1, 2, 3, 4, 5].map(function (i) {
              return '<button type="button" class="yr-star-btn" data-v="' + i + '" aria-label="' + i + ' yıldız">★</button>';
            }).join('') +
          '</div>' +
        '</div>' +
        '<div class="yr-field"><input type="text" class="yr-input yr-title-input" name="title" placeholder="Başlık (opsiyonel)" maxlength="120"></div>' +
        '<div class="yr-field"><textarea class="yr-input yr-textarea yr-body-input" name="body" placeholder="Deneyiminizi paylaşın… (opsiyonel)" maxlength="4000"></textarea></div>' +
        '<div class="yr-field">' +
          '<label class="yr-upload"><input type="file" name="images" accept="image/jpeg,image/png,image/webp" multiple hidden>' +
            '<span class="yr-upload__btn">＋ Fotoğraf ekle</span>' +
            '<span class="yr-upload__hint">opsiyonel · en fazla ' + MAX_IMG + ' görsel</span>' +
          '</label>' +
          '<div class="yr-previews"></div>' +
        '</div>' +
        '<div class="yr-form__actions">' +
          '<button type="submit" class="button yr-submit">Gönder</button>' +
          '<span class="yr-msg" role="status"></span>' +
        '</div>' +
      '</form>';
  }

  // canReview: satın almış + henüz yorumu yok → form. myReview: yorumu var → durumla göster.
  // satın almamış giriş yapmış → satın-alma uyarısı. giriş yok → giriş daveti.
  function renderForm(data) {
    data = data || {};
    if (data.myReview) {
      formEl.innerHTML = '<div class="yr-login">Bu ürün için değerlendirme yaptınız. Durumunu görmek / düzenlemek için <a href="' + esc(CFG.accountUrl || '/account') + '">hesabım</a> → Değerlendirmelerim.</div>';
      return;
    }
    if (data.canReview) { formEl.innerHTML = formMarkup(); wireForm(); return; }
    if (CFG.loggedIn) {
      formEl.innerHTML = '<div class="yr-login">Bu ürünü <b>satın aldıysan</b> değerlendirme yazabilirsin. Yalnızca satın alan müşteriler yorum yazabilir.</div>';
      return;
    }
    formEl.innerHTML = '<div class="yr-login">Değerlendirme yazmak için <a href="' + esc(CFG.loginUrl || '/account/login') + '">giriş yapın</a>. Yalnızca ürünü <b>satın alan</b> müşteriler yorum yazabilir.</div>';
  }

  function wireForm() {
    var form = formEl.querySelector('.yr-form');
    var starsWrap = form.querySelector('.yr-stars-input');
    var btns = [].slice.call(starsWrap.querySelectorAll('.yr-star-btn'));
    var rating = 0;
    function paint(v) {
      v = v || rating;
      btns.forEach(function (b) { b.classList.toggle('is-on', parseInt(b.getAttribute('data-v'), 10) <= v); });
    }
    btns.forEach(function (b) {
      b.addEventListener('click', function () { rating = parseInt(b.getAttribute('data-v'), 10); paint(); });
      b.addEventListener('mouseenter', function () { paint(parseInt(b.getAttribute('data-v'), 10)); });
    });
    starsWrap.addEventListener('mouseleave', function () { paint(); });

    var msg = form.querySelector('.yr-msg');
    var fileInput = form.querySelector('input[type=file]');
    var previews = form.querySelector('.yr-previews');
    var submitBtn = form.querySelector('.yr-submit');

    fileInput.addEventListener('change', function () {
      previews.innerHTML = '';
      [].slice.call(fileInput.files).slice(0, MAX_IMG).forEach(function (f) {
        var img = document.createElement('img');
        img.src = URL.createObjectURL(f);
        img.onload = function () { URL.revokeObjectURL(img.src); };
        previews.appendChild(img);
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      msg.className = 'yr-msg';
      if (!rating) { msg.textContent = 'Lütfen bir puan verin.'; msg.className = 'yr-msg yr-msg--err'; return; }
      if (fileInput.files.length > MAX_IMG) { msg.textContent = 'En fazla ' + MAX_IMG + ' görsel ekleyebilirsiniz.'; msg.className = 'yr-msg yr-msg--err'; return; }

      var fd = new FormData();
      fd.append('product_id', CFG.productId);
      fd.append('product_handle', CFG.productHandle || '');
      fd.append('product_title', CFG.productTitle || '');
      fd.append('rating', String(rating));
      fd.append('title', form.querySelector('.yr-title-input').value);
      fd.append('body', form.querySelector('.yr-body-input').value);
      for (var i = 0; i < fileInput.files.length; i++) fd.append('images', fileInput.files[i]);

      submitBtn.disabled = true;
      msg.textContent = 'Gönderiliyor...';
      fetch(proxy + '/reviews', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          submitBtn.disabled = false;
          if (res.ok && res.j && res.j.ok) {
            form.reset(); rating = 0; paint(); previews.innerHTML = '';
            msg.textContent = res.j.message || 'Yorumunuz alındı.';
            msg.className = 'yr-msg yr-msg--ok';
          } else {
            msg.textContent = (res.j && res.j.message) || 'Yorum gönderilemedi.';
            msg.className = 'yr-msg yr-msg--err';
          }
        })
        .catch(function () {
          submitBtn.disabled = false;
          msg.textContent = 'Bağlantı hatası, tekrar deneyin.';
          msg.className = 'yr-msg yr-msg--err';
        });
    });
  }

  // Ürün başlığının altına ortalama puan rozeti (yıldız + sayı). Tıklayınca yorumlara kaydırır.
  function injectTitleRating(s) {
    if (!s || !s.count) return;
    var title = document.querySelector('h1.product-title');
    if (!title || (title.parentNode && title.parentNode.querySelector('.yake-title-rating'))) return;
    var pct = Math.max(0, Math.min(100, (Number(s.average) || 0) / 5 * 100));
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'yake-title-rating';
    btn.setAttribute('aria-label', s.count + ' değerlendirme, yorumlara git');
    btn.style.cssText = 'display:inline-flex;align-items:center;gap:.45rem;background:none;border:0;cursor:pointer;padding:0;margin:.35rem 0 .55rem;';
    btn.innerHTML =
      '<span style="position:relative;display:inline-block;font-family:Arial,&quot;Segoe UI Symbol&quot;,sans-serif;font-size:1rem;letter-spacing:.1em;line-height:1;">' +
        '<span style="color:rgba(0,0,0,.2)">★★★★★</span>' +
        '<span style="position:absolute;left:0;top:0;overflow:hidden;white-space:nowrap;color:#e8a838;width:' + pct + '%">★★★★★</span>' +
      '</span>' +
      '<span style="font-size:.82rem;color:rgba(0,0,0,.6);text-decoration:underline;text-underline-offset:2px;">(' + s.count + ' değerlendirme)</span>';
    btn.addEventListener('click', function () { root.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
    title.insertAdjacentElement('afterend', btn);
  }

  function load() {
    fetch(proxy + '/reviews?product=' + encodeURIComponent(CFG.productId), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) { renderSummary(data.summary); injectTitleRating(data.summary); renderList(data.items); renderForm(data); })
      .catch(function () { summaryEl.innerHTML = ''; renderForm({}); });
  }

  // Son gezilen ürün → localStorage (hesapta "Son gezdiklerin" için)
  function recordRecent() {
    try {
      if (!CFG.productId) return;
      var list = JSON.parse(localStorage.getItem('yake_recent') || '[]');
      list = list.filter(function (x) { return String(x.id) !== String(CFG.productId); });
      list.unshift({
        id: CFG.productId, handle: CFG.productHandle, title: CFG.productTitle,
        image: CFG.productImage || '', price: CFG.productPrice || '',
        url: CFG.productUrl || ('/products/' + CFG.productHandle),
      });
      localStorage.setItem('yake_recent', JSON.stringify(list.slice(0, 12)));
    } catch (e) { /* yok say */ }
  }

  recordRecent();
  load();
})();
